import { premmiarApiUrl } from 'Services/Apis/clients';
import axios from 'axios';

const mockerror = () => {
  return (
    {
      errors: {
        code: "TR_API_005",
        status: "TRANSFER_LIMIT_EXCEEDED",
        message: "O valor máximo para transferência diária é de 50000 "
      },
      success: false,
      message: "Bad Request"
    }
  )
};

export const calculateServiceCharge = async (price, config, cpf) => {
  try {
    const { data } = await axios.post(
      `${premmiarApiUrl}/v1/pix/credit/transfer/calculateCash`,
      {
        points: Number(price),
        cpf: String(cpf)
      },
      {
        headers: {
          ...config,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getPixLimits = async (config) => {
  try {
    const { data } = await axios.get(
      `${premmiarApiUrl}/v1/pix/credit/transfer/limits`,
      {
        headers: {
          ...config,
        },
      }
    );
    return data;
  } catch (error) {
  }
};
export const getPixLimitsTax = async (config) => {
  try {
    const { data } = await axios.get(
      `${premmiarApiUrl}/v1/pix/credit/transfer/taxes`,
      {
        headers: {
          ...config,
        },
      }
    );
    return data?.data;
  } catch (error) {
  }
};
